import React, { useState } from "react";
import { X, Maximize2 } from "lucide-react";
import { Image } from "@/components/ui/image";
import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";

export default function PhotoGallery({ photos = [], onRemove, className = "" }) {
  const [active, setActive] = useState(null);

  if (photos.length === 0) return null;

  return (
    <>
      <div className={`flex flex-wrap gap-3 ${className}`}>
        {photos.map((url, idx) => (
          <div key={idx} className="relative">
            <Image
              src={url}
              fittingType="fill"
              className="w-20 h-20 rounded-lg overflow-hidden"
            />
            <button
              type="button"
              onClick={() => setActive(url)}
              className="absolute bottom-1 right-1 bg-black/60 text-white rounded-full w-7 h-7 flex items-center justify-center shadow-sm hover:bg-black/80 transition-colors"
              title="Expand photo"
              aria-label="Expand photo"
            >
              <Maximize2 className="w-3.5 h-3.5" />
            </button>
            {onRemove && (
              <button
                type="button"
                onClick={() => onRemove(idx)}
                className="absolute -top-2 -right-2 bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center shadow"
                title="Remove photo"
                aria-label="Remove photo"
              >
                <X className="w-3.5 h-3.5" />
              </button>
            )}
          </div>
        ))}
      </div>

      <Dialog open={active != null} onOpenChange={(o) => { if (!o) setActive(null); }}>
        <DialogContent className="max-w-4xl p-0 overflow-hidden bg-black/95 border-0 sm:rounded-xl">
          {active && (
            <Image
              src={active}
              fittingType="fit"
              className="w-full max-h-[82vh]"
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}